import React, { useEffect } from 'react';
import { Box, Typography, IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useTheme } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';

interface NotificationBannerProps {
  type: 'success' | 'error' | 'info';
  message: string;
  onClose: () => void;
  open: boolean;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({ type, message, onClose, open }) => {
  const theme = useTheme();

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, 120000); // 2 minutes

      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <Slide direction="down" in={open} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: type === 'success' ? theme.palette.success.main : type === 'error' ? theme.palette.error.main : theme.palette.info.main,
          color: 'white',
          py: 2,
          px: 3,
          boxShadow: theme.shadows[3],
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            maxWidth: '1200px',
            width: '100%',
            fontFamily: theme.typography.fontFamily,
          }}
        >
          {type === 'success' && <CheckCircleIcon sx={{ mr: 2, fontSize: 24 }} />}
          {type === 'error' && <ErrorIcon sx={{ mr: 2, fontSize: 24 }} />}
          {type === 'info' && <InfoIcon sx={{ mr: 2, fontSize: 24 }} />}
          <Typography
            variant="body1"
            sx={{
              flex: 1,
              fontWeight: 500,
              fontSize: '0.95rem',
            }}
          >
            {message}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              padding: '4px',
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      </Box>
    </Slide>
  );
};

export default NotificationBanner;